import { HAND_DRAW_COUNT } from "../data/default-config";
import type { WarchestState } from "../types/game-state";
import { drawCoinsFromBag } from "../utils/zone-utils";

export function applyDrawPhase(state: WarchestState): WarchestState {
  if (state.phase !== "DRAW_COINS") return state;

  // Draw for initiative holder first, then opponent
  const first = state.initiativeHolder;
  const second = first === "P1" ? "P2" : "P1";

  let rng = state.rngState;

  const firstResult = drawCoinsFromBag(
    state.playerZones[first],
    HAND_DRAW_COUNT,
    rng,
  );
  rng = firstResult.rngState;

  const secondResult = drawCoinsFromBag(
    state.playerZones[second],
    HAND_DRAW_COUNT,
    rng,
  );
  rng = secondResult.rngState;

  return {
    ...state,
    phase: "USE_COINS",
    activePlayer: state.initiativeHolder,
    rngState: rng,
    playerZones: {
      [first]: firstResult.zones,
      [second]: secondResult.zones,
    } as typeof state.playerZones,
  };
}
